/**
 * WebSocketContext - Глобальное управление всеми WebSocket подписками
 * ЗАЧЕМ: Единая точка управления для включения/выключения всех live подписок
 * Затрагивает: useOptionsWebSocket, useSelectedOptionsWebSocket, useFuturesWebSocket (будущий)
 */

import React, { createContext, useContext, useState, useCallback } from 'react';

const WebSocketContext = createContext();

export const useWebSocketControl = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocketControl must be used within WebSocketProvider');
  }
  return context;
};

export const WebSocketProvider = ({ children }) => {
  // State для управления всеми WebSocket подписками
  // true = все подписки активны, false = все подписки остановлены
  const [isWebSocketEnabled, setIsWebSocketEnabled] = useState(true);

  // Функция переключения состояния
  const toggleWebSocket = useCallback(() => {
    setIsWebSocketEnabled(prev => {
      const newState = !prev;
      console.log(`🎮 WebSocket Control: ${newState ? 'PLAY ▶️' : 'STOP ⏸️'} - все подписки ${newState ? 'активны' : 'остановлены'}`);
      return newState;
    });
  }, []);

  // Функция принудительного включения
  const enableWebSocket = useCallback(() => {
    console.log('🎮 WebSocket Control: Принудительное включение ▶️');
    setIsWebSocketEnabled(true);
  }, []);

  // Функция принудительного выключения
  const disableWebSocket = useCallback(() => {
    console.log('🎮 WebSocket Control: Принудительное выключение ⏸️');
    setIsWebSocketEnabled(false);
  }, []);

  const value = {
    isWebSocketEnabled,
    toggleWebSocket,
    enableWebSocket,
    disableWebSocket
  };

  return (
    <WebSocketContext.Provider value={value}>
      {children}
    </WebSocketContext.Provider>
  );
};
